import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { initialQuery } from '@supplement-bacon/sb-table-filters'
import { Setting, SettingKey } from '../models/Setting'
import { SETTINGS_URL } from '../utils/urls'

const fetchSettings = (settings: SettingKey[]) =>
  SBAPI.FetchPaginated<Setting[]>(SETTINGS_URL, {
    ...initialQuery,
    pagination: { current: 1, pageSize: 1000 },
    filters: { keys: settings },
  })

const saveSetting = (setting: Setting) => SBAPI.Post(SETTINGS_URL, setting)

export { fetchSettings, saveSetting }
